import { httpGet } from "../../api/connection";
import { GetTacticsFn, GetTechniquesFn } from "./mitre.types";

const tacticsQueryKey = ["mitre", "tactics"];

const techniquesQueryKey = ["mitre", "techniques"];

const getTactics: GetTacticsFn = async (query = {}) => {
  const { id, ...rest } = query;

  if (id) {
    return httpGet(`/mitre/tactics/${id}`, rest);
  }

  return httpGet("/mitre/tactics", rest);
};

const getTechniques: GetTechniquesFn = async (query = {}) => {
  const { id, ...rest } = query;

  if (id) {
    return httpGet(`/mitre/techniques/${id}`, rest);
  }

  return httpGet("/mitre/techniques", rest);
};

export const MitreAPI = {
  getTactics,
  getTechniques,
  tacticsQueryKey,
  techniquesQueryKey,
};
